import React from 'react';
import { Button } from 'antd';
import { navigateTo } from '../../../utils/history';

const navigateHome = () => {
  navigateTo('/');
};

const PageVerifyAccount = () => {
  return (
    <form>
      <div className='title-block mb-4 flex-column p-0'>
        <h5 className='form-title mb-4'>Email adresinizi doğrulayın</h5>

        <span className='desc'>
        Lütfen e-postanızı kontrol edin ve hesabınızı doğrulamak için doğrulama düğmesine veya bağlantısına tıklayın.
        </span>
      </div>

      <div className='elem-list'>
        <Button onClick={navigateHome} danger>
          Tekrar Onay Gönder
        </Button>

        <Button onClick={navigateHome} type='primary'>
         Destek
        </Button>
      </div>
    </form>
  );
};

export default PageVerifyAccount;
